import axiosAuth from '../../axiosMain';

async function store(data) {
  let response = await axiosAuth.post('/user_notification_channels', data);
  return response.data.data;
}

export default {
  store,
};
